module.exports = __webpack_public_path__ + "img/cp-13.ca063369.jpg";